var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueDraggableResizable',{staticClass:"text-item",attrs:{"lockAspectRatio":true,"w":_vm.w,"h":_vm.h,"x":_vm.x,"y":_vm.y},on:{"dragstop":_vm.onDragStop,"resizestop":_vm.onResizeStop}},[_c('img',{ref:"img",attrs:{"draggable":"false","src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }